import { AddedFleetEntry, ResolvedFleetEntry } from "../../fleet"
import { Resolution } from "./types"

export const getResolvedAndUnresolvedEntries = (rows: ReadonlyArray<AddedFleetEntry | ResolvedFleetEntry>) => ({
  resolved: rows.filter((row) => !!row.vehicleId).map((it) => it as ResolvedFleetEntry),
  unresolved: rows.filter((row) => !row.vehicleId).map((it) => it as AddedFleetEntry),
})

export const toResolution = (resolvedEntry: ResolvedFleetEntry): Resolution => ({
  vrn: resolvedEntry.registrationNumber,
  vehicleId: resolvedEntry.vehicleId,
  vehicle: {
    make: resolvedEntry.make,
    model: resolvedEntry.model,
    fuelType: resolvedEntry.fuelType,
    grossWeight: resolvedEntry.grossWeight,
    nominalStartYear: resolvedEntry.nominalStartYear,
    numberOfSeats: resolvedEntry.numberOfSeats,
    trimLevel: resolvedEntry.trim,
    type: resolvedEntry.type,
    abiCode: resolvedEntry.abiCode,
    abiGroup: resolvedEntry.abiGroup,
  },
})
